import api from '@/services/api';
import { INTERACTIVE_JOB_TIMEOUT_MS } from '@/utils/interactiveJobErrors';

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/**
 * POST starts a Celery job (202 + task_id). Poll until the payload is ready.
 * If the POST still returns the final payload (no task_id), that payload is used.
 */
export async function postAndPoll(postUrl, body, statusUrl, options = {}) {
  const intervalMs = options.intervalMs || 1500;
  const timeoutMs = options.timeoutMs ?? INTERACTIVE_JOB_TIMEOUT_MS;

  const start = await api.post(postUrl, body);
  const taskId = start.data && start.data.task_id;
  if (!taskId) {
    return start.data;
  }

  const deadline = Date.now() + timeoutMs;
  while (Date.now() < deadline) {
    if (typeof options.shouldAbort === 'function' && options.shouldAbort()) {
      const err = new Error('Cancelled');
      err.code = 'POLL_CANCELLED';
      throw err;
    }
    await sleep(intervalMs);
    if (typeof options.shouldAbort === 'function' && options.shouldAbort()) {
      const err = new Error('Cancelled');
      err.code = 'POLL_CANCELLED';
      throw err;
    }
    const st = await api.get(statusUrl, { params: { task_id: taskId } });
    const data = st.data || {};
    if (data.status === 'ready') {
      const payload = data.payload || {};
      const httpStatus = data.http_status || 200;
      if (httpStatus >= 400) {
        const err = new Error((payload && payload.error) || 'Request failed');
        err.response = { data: payload, status: httpStatus };
        throw err;
      }
      return payload;
    }
    if (data.status === 'failed') {
      const err = new Error(data.error || 'Request failed');
      err.response = { data: { status: 'failed', error: data.error }, status: 500 };
      throw err;
    }
  }

  throw new Error('This is taking longer than expected. Try again in a moment.');
}
